import {
  TeeTimeSlot,
  TeeTimeSlotDisplay,
  ClubCourseData,
  CurrencyData,
  TeeTimeBookingPlayer,
  TeeTimeBookingDiscount,
  ItemizedBill,
  CancelBookingSpecification,
  BookingRefund,
  RefundMode,
  PaymentMethod,
  RefundInstance,
  BookingWalletRevert,
} from './../../../../data/mygolf.data';
import { Component, HostListener } from '@angular/core';
import {
  NavParams,
  ToastController,
  Platform,
  ModalController,
} from '@ionic/angular';
import { CourseInfo, CourseHoleInfo } from '../../../../data/club-course';
import { ClubFlightService } from '../../../../providers/club-flight-service/club-flight-service';
import { TeeTimeBooking } from '../../../../data/mygolf.data';
import { Location } from '@angular/common';

import * as moment from 'moment';
import { MessageDisplayUtil } from '../../../../message-display-utils';
import { AlertController } from '@ionic/angular';
import { LoadingController } from '@ionic/angular';
import { Router, NavigationExtras } from '@angular/router';
import { BookingPlayerCharges } from 'src/data/mygolf.data - Copy';
/**
 * Created by ashok on 19/12/16.
 */
@Component({
  templateUrl: 'refund-booking-players.page.html',
  selector: 'refund-booking-players-page',
  styleUrls: ['refund-booking-players.page.scss'],
})
export class RefundBookingPlayersModal {
  appFooterHide: boolean = true;
  courses: Array<CourseInfo>;
  clubId: number;
  forDate: string;
  isClub: boolean = false;
  courseId: number;
  teeSlot: Array<TeeTimeSlotDisplay>;
  startCourses: Array<ClubCourseData>;
  changeType: string;
  currentSlot: TeeTimeBooking;
  color: string;
  currentTime: string;
  currency: CurrencyData
  refundPlayers: Array<any> = [false, false, false, false, false, false];
  refundAmountPlayers: Array<any> = [0, 0, 0, 0, 0, 0];
  refundExpiryPlayers: Array<number> = new Array<number>();
  refundReasonPlayers: Array<string> = new Array<string>();
  amountRefundable: number;
  clubPaymentMethod: string = '';//'cash';
  clubOverride: boolean = false;
  cancelBooking: boolean = false;
  refundPlayersReason: Array<string> = new Array<string>();
  refundPlayersReasonOn: Array<boolean> = new Array<boolean>();
  displayRefundHistory: boolean = false;
  displayAdjustmentHistory: boolean = false;
  fromClub: boolean = false;
  waiveMode: boolean = false;
  optionTypes: string = 'refund';
  refundMode: boolean = true;
  waiveOffAmount: number = 0;
  waiveOffReason: string = '';
  bookingDiscounts: Array<any> = new Array<any>();
  adjustableAmount: number = 0;
  cancelReason: string = '';
  assignmentDone: boolean = false;
  bookingItemBill: ItemizedBill;
  refresherBill: boolean = false;
  closeCancelReason: boolean = true;
  mode: string;
  paymentMethodList: Array<PaymentMethod>;
  appAttribute;
  any;
  includeTaxes: boolean = true;
  isAdditionalCharges: boolean = false;
  raincheckMode: boolean = false;
  raincheckOptionList: Array<any> = [];
  enableRaincheck: boolean = true;
  refundReasonList: Array<any> = new Array<any>();
  setExpiryDays: number = 14;
  selectedRaincheckOpt: any;
  constructor(
    private flightService: ClubFlightService,
    private navParams: NavParams,
    private toastCtl: ToastController,
    private modalCtl: ModalController,
    private platform: Platform,
    private router: Router,
    private location: Location,
    private alertCtrl: AlertController,
    private loadingCtrl: LoadingController
  ) {
    this.courses = navParams.get("courses");
    this.clubId = navParams.get("clubId");
    this.forDate = navParams.get("forDate");
    this.courseId = navParams.get("courseId");
    this.changeType = navParams.get("changeType");
    this.currentSlot = navParams.get("currentSlot")
    this.currency = navParams.get("currency");
    this.fromClub = navParams.get("fromClub");
    this.mode = navParams.get('mode');
    if (this.router.getCurrentNavigation()) {
      this.currentSlot =
        this.router.getCurrentNavigation().extras.state.currentSlot;
      this.forDate = this.router.getCurrentNavigation().extras.state.forDate;
      this.courseId = this.router.getCurrentNavigation().extras.state.courseId;
      this.changeType =
        this.router.getCurrentNavigation().extras.state.changeType;
      this.currency = this.router.getCurrentNavigation().extras.state.currency;
      this.fromClub = this.router.getCurrentNavigation().extras.state.fromClub;
      this.mode = this.router.getCurrentNavigation().extras.state.mode;
      this.optionTypes = this.router.getCurrentNavigation().extras.state.type;
    }
    if (this.changeType && this.changeType === 'slot') this.isClub = false;
    else if (this.changeType && this.changeType === 'course')
      this.isClub = true;
    if (navParams.get('type')) this.optionTypes = navParams.get('type');

    if (this.mode === 'cancel') {
      this.cancelBooking = true;
      this.closeCancelReason = false;
    }

    if (this.currentSlot)
      this.currentSlot.bookingPlayers.forEach(
        (t: TeeTimeBookingPlayer, idx: number) => {
          this.refundPlayersReasonOn[idx] = false;
          this.refundPlayersReason[idx] = '';
        }
      );
    this.bookingDiscounts = JSON.parse(
      JSON.stringify(this.currentSlot.bookingDiscounts)
    );
    let _totalWaive = 0;
    if (this.bookingDiscounts.length > 0)
      this.bookingDiscounts.forEach((bd) => {
        bd.toggleDetails = false;
        if (bd.adhocWaiver) _totalWaive += bd.amountDeducted;
      });
    if (this.currentSlot) {
      this.assignmentDone = this.currentSlot.assignmentDone;
    }
    this.raincheckOptionList.push({
      id: 'CLBC',
      name: 'Without expiry',
      expires: false,
      expiryDays: 0
    })
    this.raincheckOptionList.push({
      id: 'WALT',
      name: 'With expiry',
      expires: true,
      expiryDays: 14
    })
  }

  innerWidth: any;
  ngOnInit() {
    this.innerWidth = window.innerWidth;
  }
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.innerWidth = window.innerWidth;
  }
  ionViewDidEnter() {
    if (this.currentSlot) this.getBookingItemizedBill();
    this.refreshPaymentMethod();
    this.getAppAttribute();
    this.initReasonRefundList();
  }
  close() {
    this.modalCtl.dismiss();
  }
  selectHole(hole: CourseHoleInfo, whichNine: number) {
    this.modalCtl.dismiss({
      hole: hole,
      whichNine: whichNine,
    });
  }

  getTeeTimeBookingList() {
    let _clubCourseId;
    this.startCourses = [];
    _clubCourseId = this.isClub ? this.clubId : this.courseId;
    this.flightService.getTeeTimeSlot(this.forDate, this.isClub, _clubCourseId).subscribe((data: Array<TeeTimeSlotDisplay>) => {
      this.teeSlot = data;
      if (this.changeType === 'course') {
        this.teeSlot = this.teeSlot.filter((tee: TeeTimeSlotDisplay) => {
          return tee.slot.teeOffTime === this.currentSlot.slotAssigned.teeOffTime && tee.slot.startCourse.id !== this.currentSlot.slotAssigned.startCourse.id
        })
      } else {
        this.teeSlot = this.teeSlot.filter((tee: TeeTimeSlotDisplay) => {
          return tee.slot.teeOffTime !== this.currentSlot.slotAssigned.teeOffTime
        })
      }
      this.teeSlot.forEach((t: TeeTimeSlotDisplay) => { this.startCourses.push(t.slot.startCourse); })
      this.startCourses = this.getUnique(this.startCourses, 'id')
      this.startCourses.sort((a, b) => {
        if (a.displayOrder < b.displayOrder) return -1
        if (a.displayOrder > b.displayOrder) return 1
        else 0
      })
    });
  }

  getUnique(arr, comp) {
    // store the comparison  values in array
    const unique = arr
      .map((e) => e[comp])
      // store the indexes of the unique objects
      .map((e, i, final) => final.indexOf(e) === i && i)
      // eliminate the false indexes & return unique objects
      .filter((e) => arr[e])
      .map((e) => arr[e]);
    return unique;
  }

  changeSlot(slot: TeeTimeSlotDisplay, type?: string) {
    if (!slot.available && type === 'slot') return false;
    this.flightService.getBookingFlightList(this.clubId, moment(slot.slot.teeOffDate).format('YYYY-MM-DD'), true).subscribe((data) => {
      let _flightList: Array<TeeTimeBooking>;
      let _hasFlight: Array<TeeTimeBooking>;
      if (data) {
        _flightList = data.flightList;
        _hasFlight = _flightList.filter((t: TeeTimeBooking) => {
          return (t.slotAssigned.slotNo === slot.slot.slotNo) && (t.slotAssigned.slotDayId === slot.slot.slotDayId)
        })
      }
      if (_hasFlight && _hasFlight.length > 0) {
        if (_hasFlight[0].flight && _hasFlight[0].flight.status === 'PlayFinished') {
          MessageDisplayUtil.showMessageToast('There is Finished Flight in this slot. Please choose different slot.',
            this.platform, this.toastCtl, 3000, "bottom");
          return false;
        } else {
          this.modalCtl.dismiss({
            newSlot: slot,
            currentSlot: this.currentSlot
          });
        }
      } else {
        this.modalCtl.dismiss({
          newSlot: slot,
          currentSlot: this.currentSlot,
        });
      }
    });
  }
  getSlotDetails(slot: TeeTimeSlotDisplay, attribute: string) {
    switch (attribute) {
      case 'time':
        let _time = moment(slot.slot.teeOffTime, 'HH:mm:ss').format('hh:mm A');
        return _time;
    }
  }

  getCurrentSlotDetails(attribute) {
    switch (attribute) {
      case 'time':
        let _time = moment(this.currentSlot.slotAssigned.teeOffTime, 'HH:mm:ss').format('hh:mm A');
        return _time;
      case 'courseName':
        let _courseName = this.currentSlot.slotAssigned.startCourse.name;
        return _courseName;
      case 'date':
        let _date = moment(this.currentSlot.slotAssigned.teeOffDate, 'YYYY-MM-DD').format('ddd, DD MMM YYYY');
        return _date;
    }
  }

  getSlotClass(slot: TeeTimeSlotDisplay) {
    if (this.changeType === 'course') return 'slot-available';
    else {
      // return this.color
      if (slot.available) return 'slot-available';
      else return 'slot-not-available';
    }
  }

  getNewPlayerSlotDetails(bookingPlayers: any, slot: number, attribute) {
    let _currentPlayer = bookingPlayers;
    let idx = slot - 1;
    let _id;

    if (_currentPlayer) _id = '(#' + _currentPlayer.id + ')';
    else '';
    switch (attribute) {
      case 'name':
        return _currentPlayer.playerName;
      case 'id':
        return _id;
      case 'image':
        if (_currentPlayer && !_currentPlayer.player) return '';
        else return (_currentPlayer && _currentPlayer.image ? _currentPlayer.image : _currentPlayer.profile ? _currentPlayer.profile : '');
    }
  }

  getPlayerSlotDetails(slot: number, attribute: string) {
    let _currentPlayer = this.currentSlot.bookingPlayers;
    let idx = slot - 1;
    let _id;
    if (_currentPlayer[idx] && _currentPlayer[idx].player)
      _id = '(#' + _currentPlayer[idx].player.id + ')';
    else '';
    switch (attribute) {
      case 'name':
        return _currentPlayer[idx].playerName;
      case 'id':
        return _id;
      case 'image':
        if (_currentPlayer[idx] && !_currentPlayer[idx].player) return '';
        else return (_currentPlayer[idx].player && _currentPlayer[idx].player.image ? _currentPlayer[idx].player.image : _currentPlayer[idx].player.profile ? _currentPlayer[idx].player.profile : '');
      case 'isContactComplete':
        let _newPlayer = (_currentPlayer[idx].player) ? false : true;
        if (_newPlayer) return _currentPlayer[idx].playerContact && _currentPlayer[idx].playerContact.length > 0
        else {
          let _currPlAddress = _currentPlayer[idx].player.address;
          if (_currPlAddress.address1 &&
            _currPlAddress.state &&
            _currPlAddress.city &&
            _currPlAddress.postCode &&
            _currPlAddress.phone1) return true
          else return false;
        }
      case 'discount':
        return '<span style="color:red">No promotion</span>'
    }
  }
  onRefundMethodSelect() {
    if (this.clubPaymentMethod === 'cwlt') {
      this.refundPlayers.forEach((player, idx) => {
        this.refundPlayers[idx] = false;
        this.refundPlayersReasonOn[idx] = false;
        this.refundPlayersReason[idx] = '';
        this.refundAmountPlayers[idx] = 0;
      })
    }
  }
  onRefundToPlayer(event, player: TeeTimeBookingPlayer, i: number) {
    let _totalAmount = 0;
    _totalAmount = this.refundAmountPlayers.reduce((a, b) => {
      return a + b;
    });
    if (this.refundPlayers[i] === true) {
      if (this.optionTypes === 'raincheck') {
        setTimeout(() => {
          this.getPlayerBillItems(i, player)
          this.refundPlayersReason[i] = "Raincheck of amount " + this.currency.symbol + " " + this.refundAmountPlayers[i].toFixed(2);
        }, 500);
      } else {
        setTimeout(() => {
          let _refund;
          _refund = Number((this.amountRefundable - _totalAmount).toFixed(2));
          this.refundAmountPlayers[i] = _refund > 0 ? _refund : 0;
        }, 0)
      }
    }
    if (this.refundPlayers[i] === false) {
      this.refundPlayersReasonOn[i] = false;
      this.refundPlayersReason[i] = '';
      this.refundAmountPlayers[i] = 0;
    }
  }

  getTotalRefundAmount() {
    if (this.refundAmountPlayers.length === 0) return false;
    let _total = this.refundAmountPlayers.reduce((a, b) => {
      return a + b;
    });
    return _total;
  }

  async onApplyRefundClick(onlyCancel?: boolean) {
    if (this.optionTypes === 'raincheck') {
      this.onApplyWaiveOff();
    }
    if (this.cancelBooking) {
      if ((this.currentSlot.totalRefund === this.currentSlot.amountPaid && onlyCancel) || onlyCancel) {
        let _cancelBookingSpec: CancelBookingSpecification = {};
        _cancelBookingSpec.bookingId = this.currentSlot.id;
        _cancelBookingSpec.refundAmount = null;
        _cancelBookingSpec.refundSplits = [];
        _cancelBookingSpec.reason = this.cancelReason;
        let alert = await this.alertCtrl.create({
          header: 'Booking Cancellation',
          message: 'Are you sure you want to cancel this booking?',
          buttons: [{
            text: 'No',
            role: 'cancel'
          },
          {
            text: 'Yes',
            handler: () => {
              this.goApplyRefundAndCancel(_cancelBookingSpec);
            }
          },]
        });
        alert.present();
      }
      else this.onApplyRefundAndCancel();
    } else {
      if (this.optionTypes === 'raincheck') {
        setTimeout(() => {
          this.goApplyRefund();
        }, 1000)
      } else this.onApplyRefund();
    }
  }

  async onApplyRefundAndCancel() {
    let _totalAmount = 0;
    _totalAmount = this.refundAmountPlayers.reduce((a, b) => {

      return a + b;
    });
    if (!this.clubPaymentMethod || this.clubPaymentMethod && this.clubPaymentMethod.length === 0) {
      MessageDisplayUtil.showMessageToast('Please select a refund method to proceed.',
        this.platform, this.toastCtl, 5000, "bottom");
      return false;
    }
    if (this.getRefundableAmount() < 0) {
      MessageDisplayUtil.showMessageToast('There is no refundable amount available',
        this.platform, this.toastCtl, 5000, "bottom");
      return false;
    }
    if (this.currentSlot.amountPaid < this.getRefundableAmount()) {
      MessageDisplayUtil.showMessageToast('Amount paid is less than refundable amount',
        this.platform, this.toastCtl, 5000, "bottom");
      return false;
    }
    if (_totalAmount === 0) {
      MessageDisplayUtil.showMessageToast('Please select a player and enter refund amount',
        this.platform, this.toastCtl, 5000, "bottom");
      return false;
    }
    else if (!this.clubOverride && this.getRefundableAmount() < _totalAmount) {
      MessageDisplayUtil.showMessageToast('Total refund amount is more than refundable amount',
        this.platform, this.toastCtl, 5000, "bottom");
      return false;
    }

    let _players: Array<TeeTimeBookingPlayer> = new Array<TeeTimeBookingPlayer>();
    _players.push(...this.currentSlot.bookingPlayers);
    let _noReason: boolean = false;

    _players.forEach((t: TeeTimeBookingPlayer, idx: number) => {
      if (this.refundPlayers[idx]) {
        if (!this.refundPlayersReason[idx] || this.refundPlayersReason[idx].length === 0) {
          MessageDisplayUtil.showMessageToast('Please enter a reason to refund for ' + t.playerName,
            this.platform, this.toastCtl, 5000, "bottom");
          _noReason = true;
          return false;
        }
      }
    })
    if (_noReason) return false;
    let _bookingId = this.currentSlot.id;
    let _cancelBookingSpec: CancelBookingSpecification = {}
    let _playerRefund = this.currentSlot.bookingPlayers.filter((bp, bpIdx) => {
      if (bp && bp.player) return true
    }).map((bp) => {
      return bp.player
    });
    if (this.currentSlot.bookedByPlayer) {
      _playerRefund.push(this.currentSlot.bookedByPlayer)
    }
    let _date = moment().toDate();
    let _refundMode: RefundMode = 'Unknown'
    if (this.clubPaymentMethod === 'cash') _refundMode = 'Cash';
    else if (this.clubPaymentMethod === 'btrf') _refundMode = 'BankTransfer';
    else if (this.clubPaymentMethod === 'clbc') _refundMode = 'ClubCredit';
    else if (this.clubPaymentMethod === 'm2uc') _refundMode = 'M2UCredit';
    let _refundText;
    switch (this.clubPaymentMethod) {
      case 'cash':
        _refundText = 'Cash';
        break;
      case 'clbc':
        _refundText = 'myGolf2u Club Credit';
        break;
      case 'btrf':
        _refundText = 'Bank Transfer';
        break;
      case 'm2uc':
        _refundText = 'myGolf2u Credit';
        break;
      case 'cwlt':
        _refundText = 'Club eWallet';
        break;
      case 'offcta':
        _refundText = 'Revert to Account';
        break;
    }

    let _playerRefunded: Array<BookingRefund> = new Array<BookingRefund>();

    _playerRefund.forEach((pr, idx) => {
      if (this.refundAmountPlayers[idx] > 0)
        _playerRefunded[idx] = {
          playerRefunded: pr,
          refundAmount: this.refundAmountPlayers[idx],
          refundDate: _date,
          refundMode: _refundMode,
          description: this.refundPlayersReason[idx],

        }
    });

    let _playerWalletRefund: Array<BookingWalletRevert> = new Array<BookingWalletRevert>();
    if (this.clubPaymentMethod === 'cwlt') {
      let _players: Array<TeeTimeBookingPlayer> = new Array<TeeTimeBookingPlayer>();
      _players.push(...this.getBookingPlayers());
      let _params = {};
      let _walletId;
      let _topUpId;
      let _transactionId;
      let _amount;
      let _playerHasWallet;
      _players.forEach((t: any, idx: number) => {
        if (this.clubPaymentMethod === 'cwlt') {
          if (this.refundPlayers[idx]) {
            _playerHasWallet = this.bookingItemBill.payments.find((pay) => {
              return pay.paymentMethod.toLowerCase() === 'club wallet' && pay.playerId === this.getSinglePlayer(idx).id;
            })
            _topUpId = _playerHasWallet.walletTopUpId;
            _walletId = _playerHasWallet.walletId;
            _transactionId = _playerHasWallet.walletTransactionId;
            _amount = this.refundAmountPlayers[idx];
            _params = {
              bookingId: _bookingId,
              topUpId: _topUpId,
              amount: _amount,
              description: 'Booking Reference:' + this.currentSlot.bookingReference + '. Reason : ' + this.refundPlayersReason[idx],
              walletId: _walletId,
              transactionId: _transactionId,
            }
            _playerWalletRefund.push(_params);
          }
        }
      });
    }
    _cancelBookingSpec.bookingId = _bookingId;
    _cancelBookingSpec.refundAmount = _totalAmount;
    _cancelBookingSpec.reason = this.cancelReason;
    if (this.clubPaymentMethod === 'cwlt') {
      _cancelBookingSpec.walletReverts = _playerWalletRefund;
      _cancelBookingSpec.refundSplits = [];
    } else {
      _playerRefunded = _playerRefunded.filter((p) => {
        return p.refundAmount > 0
      })
      _cancelBookingSpec.refundSplits = _playerRefunded;
    }

    let alert = await this.alertCtrl.create({
      header: 'Refund Booking',
      message: 'Total refund amount is ' + this.currency.symbol + ' ' + this.numberWithCommas(_totalAmount) + ' via ' + _refundText + ". Do you want to proceed?",
      buttons: [{
        text: 'No',
        role: 'cancel'
      }, {
        text: 'Yes',
        handler: () => {
          this.goApplyRefundAndCancel(_cancelBookingSpec);
        }
      },]
    });
    alert.present();
  }

  goApplyRefundAndCancel(cancelBookingSpec) {
    let _cancelBookingSpec = cancelBookingSpec;
    this.flightService.cancelBookingByClub(_cancelBookingSpec).subscribe((data) => {
      if (data) {
        this.modalCtl.dismiss({
          changeValue: data,
          needRefresh: true,
          fromClub: this.fromClub,
        });
      }
    }, (error) => {
      let _error = error;
      let _msg = _error.errorMessage;
      MessageDisplayUtil.showMessageToast(_msg,
        this.platform, this.toastCtl, 3000, "bottom")
      return false;
    })
  }
  async onApplyRefund() {
    let _totalAmount = 0;
    _totalAmount = this.refundAmountPlayers.reduce((a, b) => {
      return a + b;
    });
    if (!this.clubPaymentMethod || this.clubPaymentMethod && this.clubPaymentMethod.length === 0) {
      MessageDisplayUtil.showMessageToast('Please select a club payment method to proceed.',
        this.platform, this.toastCtl, 5000, "bottom");
      return false;
    }
    if (this.getRefundableAmount() < 0) {
      MessageDisplayUtil.showMessageToast('There is no refundable amount available',
        this.platform, this.toastCtl, 5000, "bottom");
      return false;
    }
    if (this.currentSlot.amountPaid < this.getRefundableAmount()) {
      MessageDisplayUtil.showMessageToast('Amount paid is less than refundable amount',
        this.platform, this.toastCtl, 5000, "bottom");
      return false;
    }
    if (_totalAmount === 0) {
      MessageDisplayUtil.showMessageToast('Please select a player and enter refund amount',
        this.platform, this.toastCtl, 5000, "bottom");
      return false;
    }
    else if (this.getRefundableAmount() < _totalAmount) {
      MessageDisplayUtil.showMessageToast('Total refund amount is more than refundable amount',
        this.platform, this.toastCtl, 5000, "bottom");
      return false;
    }

    let _bookingId = this.currentSlot.id;
    let _refundMode = this.clubPaymentMethod;
    let _refundText;
    switch (_refundMode) {
      case 'cash':
        _refundText = 'Cash';
        break;
      case 'clbc':
        _refundText = 'myGolf2u Club Credit';
        break;
      case 'btrf':
        _refundText = 'Bank Transfer';
        break;
      case 'm2uc':
        _refundText = 'myGolf2u Credit';
        break;
      case 'cwlt':
        _refundText = 'Club eWallet';
        break;
      case 'offcta':
        _refundText = 'Revert to Account';
        break;
    }
    let _players: Array<TeeTimeBookingPlayer> = new Array<TeeTimeBookingPlayer>();
    _players.push(...this.currentSlot.bookingPlayers);

    let _noReason: boolean = false;

    _players.forEach((t: TeeTimeBookingPlayer, idx: number) => {
      if (this.refundPlayers[idx]) {
        if (!this.refundPlayersReason[idx] || this.refundPlayersReason[idx].length === 0) {
          MessageDisplayUtil.showMessageToast('Please enter a reason to refund for ' + t.playerName,
            this.platform, this.toastCtl, 5000, "bottom");
          _noReason = true;
          return false;
        }
      }
    })
    if (_noReason) return false;

    if (0 && this.optionTypes === 'raincheck') this.goApplyRefund();
    else {
      let alert = await this.alertCtrl.create({
        header: 'Refund Booking',
        message: 'Total refund amount is ' + this.currency.symbol + ' ' + _totalAmount + ' via ' + _refundText + ". Do you want to proceed?",
        buttons: [
          {
            text: 'No',
            role: 'cancel',
          },
          {
            text: 'Yes',
            handler: () => {
              this.goApplyRefund();
            },
          },
        ],
      });
      alert.present();
    }
  }
  getSinglePlayer(idx: number) {
    return this.getBookingPlayers()[idx];
  }
  goApplyRefund() {
    let _bookingId = this.currentSlot.id;
    let _refundMode = this.clubPaymentMethod;
    let _players: Array<TeeTimeBookingPlayer> = new Array<TeeTimeBookingPlayer>();
    _players.push(...this.getBookingPlayers());
    let _reason = this.cancelReason;
    let _params = {};
    let _walletId;
    let _topUpId;
    let _transactionId;
    let _amount;
    let _playerHasWallet;
    _players.forEach(async (t: any, idx: number, arr) => {
      if (this.clubPaymentMethod === 'cwlt') {
        if (this.refundPlayers[idx]) {
          _playerHasWallet = this.bookingItemBill.payments.find((pay) => {
            return pay.paymentMethod.toLowerCase() === 'club wallet' && pay.playerId === this.getSinglePlayer(idx).id;
          })
          _topUpId = _playerHasWallet.walletTopUpId;
          _walletId = _playerHasWallet.walletId;
          _transactionId = _playerHasWallet.walletTransactionId;
          _amount = this.refundAmountPlayers[idx];
          _params = {
            bookingId: _bookingId,
            topUpId: _topUpId,
            amount: _amount,
            remarks: 'Booking Reference:' + this.currentSlot.bookingReference + '. Reason : ' + this.refundPlayersReason[idx],
            walletId: _walletId,
          }
          this.flightService.setRefundWalletBalance(_params)
            .subscribe((data: any) => {
              this.modalCtl.dismiss({
                needRefresh: true,
                fromClub: this.fromClub
              });
            }, (error) => {
              let _error = error;
              let _msg;
              if (_error && _error.error) _msg = _error.error;
              else _msg = "Something is wrong, please try again."

              MessageDisplayUtil.showMessageToast(_msg,
                this.platform, this.toastCtl, 5000, "bottom");
              return false;
            }, () => { })
        }
      } else {
        if (this.refundPlayers[idx]) {
          let _reason = '';
          if (this.clubPaymentMethod === 'offcta')
            _reason = '[Offline] Revert to account | ' + this.refundPlayersReason[idx];
          else _reason = this.refundPlayersReason[idx];
          let loader = await this.loadingCtrl.create({
            showBackdrop: false,
            duration: 5000,
            message: 'Processing...'
          });
          loader.present().then(() => {
            this.onSetRefundBookingPlayer(idx, _bookingId, _players[idx].id, this.refundAmountPlayers[idx], _reason,
              _refundMode.toUpperCase(), this.refundReasonPlayers[idx])
              .then((result: any) => {
                //    if(result && result.status === 'success')
                if (arr.length - 1 === idx) {
                  loader.dismiss().then(() => {
                    this.modalCtl.dismiss({
                      needRefresh: true,
                      fromClub: this.fromClub
                    });
                  })
                }
              }).catch((error) => {
                if (loader) loader.dismiss();
                if (error && error.error) {
                  let _error = error.error;
                  let _msg;
                  if (_error && _error.error) _msg = _error.error;
                  else _msg = "Something is wrong, please try again."
                  MessageDisplayUtil.showMessageToast(_msg, this.platform, this.toastCtl, 5000, "bottom"); return false;
                }
              })
          });
        }
      }
    })
  }
  promise = Promise.resolve();
  onSetRefundBookingPlayer(idx: number, bookingId: number, playerId: number, amount: number, reason: string, refundMode: string, refundReason: string) {
    return new Promise((resolve, reject) => {
      let _validUntil = null;
      if (this.selectedRaincheckOpt === 'WALT') _validUntil = moment().add(this.setExpiryDays, 'days').format("YYYY-MM-DD")
      setTimeout(() => {
        this.flightService.setRefundBookingPlayer(bookingId, playerId, amount, reason, refundMode, refundReason, _validUntil)
          .subscribe((data: any) => {
            resolve({
              status: 'success',
              data: data
            });
          }, (error) => {
            reject({
              status: 'failed',
              error: error
            })
          }, () => { })
      }, idx * 1000)

    })
  }

  getRefundableAmount() {
    let _amountPayable = this.currentSlot.amountPayable;
    let _amountDeduction = this.currentSlot.totalDeductions;
    let _amountPaid = this.currentSlot.amountPaid;
    let _amountRefund = this.currentSlot.totalRefund;
    this.amountRefundable = (_amountPayable + _amountRefund - (_amountPaid + _amountDeduction));
    this.amountRefundable = -1 * this.amountRefundable;
    if (this.amountRefundable < 0) this.amountRefundable = 0;
    if (this.clubOverride)
      return Number((_amountPaid - _amountRefund).toFixed(2));
    else return Number(this.amountRefundable.toFixed(2));
  }

  toggleRefundHistory() {
    this.displayRefundHistory = !this.displayRefundHistory;
  }
  toggleAdjustmentHistory() {
    this.displayAdjustmentHistory = !this.displayAdjustmentHistory;
  }

  toggleWaiveMode() {
    this.waiveMode = this.clubOverride;
  }

  async onApplyWaiveOffClick() {
    let _bookingId = this.currentSlot.id;
    let _amount = Math.abs(this.waiveOffAmount);
    let _reason = this.waiveOffReason;
    let _balance = this.getWaiveOffBalance() + _amount;
    let _chargeable;
    if (!_amount || _amount === 0) {
      MessageDisplayUtil.showMessageToast('Please enter valid waive-off amount', this.platform, this.toastCtl, 5000, "bottom");
      return;
    } else if (_amount > _balance) {
      MessageDisplayUtil.showMessageToast('Waive-off amount is more than balance amount left ',
        this.platform, this.toastCtl, 5000, "bottom");
      return;
    } else if (!_reason || _reason.length === 0) {
      MessageDisplayUtil.showMessageToast('Please enter a reason to waive-off',
        this.platform, this.toastCtl, 5000, "bottom");
      return;
    }

    let alert = await this.alertCtrl.create({
      header: 'Booking Adjustment',
      message:
        'Total adjustment amount is ' + this.currency.symbol + ' ' + this.numberWithCommas(_amount) + '. Do you want to proceed?',
      buttons: [
        {
          text: 'No',
          role: 'cancel',
        },
        {
          text: 'Yes',
          handler: () => {
            this.onApplyWaiveOff();
          },
        },
      ],
    });
    alert.present();
  }

  numberWithCommas(x) {
    if (!x) return x;
    else return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  applyBookingWaiveOff() { }

  getDisabledMode(type?: string) { }

  setOptionType(type?: number) {
    switch (type) {
      case 1: //refund
        this.refundMode = true;
        this.waiveMode = false;
        this.clubOverride = false;
        this.raincheckMode = false;
        this.clearRefundDetails();
        break;
      case 2: //adjustment
        this.refundMode = false;
        this.waiveMode = true;
        this.clubOverride = true;
        this.raincheckMode = false;
        this.getBookingItemizedBill();
        break;
      case 3: //raincheck
        this.refundMode = true;
        this.waiveMode = true;
        this.clubOverride = true;
        this.raincheckMode = true;
        this.getBookingItemizedBill();
        break;
    }
  }

  onApplyWaiveOff() {
    let _bookingId = this.currentSlot.id;
    let _amount = this.waiveOffAmount;
    let _reason = this.waiveOffReason;
    this.flightService.bookingWaiveOff(_bookingId, _amount, _reason).subscribe(
      (data) => {
        if (data) {
          let _data = data;
          if (_data) {
            this.bookingDiscounts = [];
            this.currentSlot = _data;
            this.bookingDiscounts = JSON.parse(JSON.stringify(_data.bookingDiscounts));
            let _totalWaive;
            if (this.bookingDiscounts.length > 0)
              this.bookingDiscounts.forEach((bd) => {
                bd.toggleDetails = false;
                _totalWaive += bd.amountDeducted;
              });
            this.getBookingItemizedBill();
          }
        }
      }, (error) => {
        let _error;
        let _msg = '';
        if (error && error.errorMessage) {
          _error = error;
        }
        else if (_error && _error.message) _msg = _error.message
        else if (_error && _error.errorMessage) _msg = _error.errorMessage;
        else _msg = 'Only club admin is allowed'
        MessageDisplayUtil.showMessageToast(_msg, this.platform, this.toastCtl, 5000, "bottom");
        return;
      }, () => {
        this.waiveOffAmount = 0;
        this.waiveOffReason = '';
        MessageDisplayUtil.showMessageToast('Successfully made adjustment', this.platform, this.toastCtl, 5000, "bottom");
        return;
      })
  }

  getWaiveOffItems() {
    let _waiveOffItems = [];
    _waiveOffItems = this.bookingDiscounts.filter((bd) => {
      return bd.adhocWaiver
    }).sort((a, b) => {
      if (a.sequence > b.sequence) return -1;
      else if (a.sequence < b.sequence) return 1;
      else return 0;
    });
    return _waiveOffItems;
  }

  getWaiveOffBalance() {
    let _totalWaive = 0;
    let _totalCharges = 0;
    if (this.bookingItemBill) {
      if (this.includeTaxes) _totalCharges = this.bookingItemBill.totalCharges + this.bookingItemBill.taxes;
      else _totalCharges = this.bookingItemBill.totalCharges;
    }
    if (!this.adjustableAmount) {
      if (this.bookingDiscounts.length > 0)
        this.bookingDiscounts.forEach((bd) => {
          if (bd.adhocWaiver)
            _totalWaive += bd.amountDeducted;
        })
      this.adjustableAmount = _totalCharges - _totalWaive;
    }
    let _total = this.adjustableAmount - this.waiveOffAmount;
    return _total;
  }

  async onUndoWaiveOffClick(item: TeeTimeBookingDiscount) {
    if (!item.adhocWaiver) return;
    let _totalAmount = item.amountDeducted;
    let alert = await this.alertCtrl.create({
      header: 'Undo Adjustment',
      message:
        'Total undo amount is ' + this.currency.symbol + ' ' + _totalAmount + '. Do you want to proceed?',
      buttons: [
        {
          text: 'No',
          role: 'cancel',
        },
        {
          text: 'Yes',
          handler: () => {
            this.undoBookingWaiveOff(item);
          },
        },
      ],
    });
    alert.present();
  }

  undoBookingWaiveOff(item: TeeTimeBookingDiscount) {
    this.bookingDiscounts = [];
    let _item = item;
    let _bookingId = this.currentSlot.id;
    this.flightService.undoBookingWaiveOff(_bookingId, _item.sequence).subscribe((data) => {
      if (data) {
        this.bookingDiscounts = [];
        let _data = data;
        // if(_data) this.currentSlot = _data;
        if (_data) {
          this.currentSlot = _data;
          this.bookingDiscounts = [];
          // this.bookingDiscounts.push(..._data.bookingDiscounts);
          this.bookingDiscounts = JSON.parse(
            JSON.stringify(_data.bookingDiscounts)
          );
          let _totalWaive;
          if (this.bookingDiscounts.length > 0)
            this.bookingDiscounts.forEach((bd) => {
              bd.toggleDetails = false;
              _totalWaive += bd.amountDeducted;
            });
          // this.adjustableAmount = this.bookingItemBill.totalCharges - _totalWaive;
        }
      }
    },
      (error) => { },
      () => {
        this.getBookingItemizedBill();
      }
    );
  }

  onToggleWaiveDetail(item) {
    this.bookingDiscounts.forEach((bd) => {
      if (item !== bd) bd.toggleDetails = false;
    });
    item.toggleDetails = !item.toggleDetails;
  }

  async getBookingItemizedBill(afterAssignment?: boolean) {
    this.refresherBill = true;
    let _bookingId = this.currentSlot.id;
    let _afterAssignment = this.assignmentDone;
    let loader = await this.loadingCtrl.create({
      showBackdrop: false,
      duration: 5000,
      message: 'Refreshing bill...',
    });
    let _bookingItemBill;

    loader.present().then(() => {
      this.flightService
        .getBookingItemizedBill(_bookingId, _afterAssignment)
        .subscribe(
          (data: Response) => {
            this.bookingItemBill = {};
            loader.dismiss().then(() => {
              this.refresherBill = false;
              let _totalWaive = 0;
              if (data) {
                _bookingItemBill = data;
                this.bookingItemBill = _bookingItemBill;
                this.bookingItemBill.payments.sort((a, b) => {
                  if (a.datePaid < b.datePaid) return 1;
                  else if (a.datePaid > b.datePaid) return -1;
                  else return 0;
                });



                if (this.bookingDiscounts.length > 0)
                  _totalWaive = this.bookingDiscounts
                    .map((bd) => {
                      if (bd.adhocWaiver) return bd.amountDeducted;
                    })
                    .reduce((a, b) => {
                      return a + b;
                    });
                if (this.includeTaxes) {
                  this.adjustableAmount =
                    this.bookingItemBill.totalCharges +
                    this.bookingItemBill.taxes -
                    _totalWaive;
                } else
                  this.adjustableAmount =
                    this.bookingItemBill.totalCharges - _totalWaive;
              }
            });
          },
          (error) => {
            this.refresherBill = false;
            this.bookingItemBill = {};
          },
          () => {
            // if(this.grpPayment) this.getPaymentGateway(this.bookingSlot.clubData.address.countryData.id);
          }
        );
    });
  }

  getRefundBalance() {
    let _totalAmount = 0;
    _totalAmount = this.refundAmountPlayers.reduce((a, b) => {

      return a + b;
    });
    if (!_totalAmount || _totalAmount === 0) return false;
    let _balance = 0;
    _balance = this.getRefundableAmount() - _totalAmount;
    return _balance.toFixed(2);
  }

  getBookingPlayers() {
    let _bookingPlayers = [];
    this.currentSlot.bookingPlayers.forEach((p) => {
      if (p.player) _bookingPlayers.push(p.player);
    });
    let _paidPlayers = [];

    if (this.currentSlot.payments) {
      this.currentSlot.payments.filter((pp) => {
        let _isPlayer = true;
        if (pp.payingPlayer) {
          _bookingPlayers.filter((bp) => {
            if (bp.player && bp.player.id)
              if (bp.player.id === pp.payingPlayer.id) _isPlayer = false;
          });
          if (_isPlayer) _bookingPlayers.push(pp.payingPlayer);
        }
      });
    }


    return this.getUnique(_bookingPlayers, 'id');
  }

  refreshPaymentMethod() {
    this.paymentMethodList = [];
    this.flightService
      .getPaymentMethodList()
      .subscribe((data: Array<PaymentMethod>) => {

        if (data) {
          this.paymentMethodList = data;
        }
      });
  }

  getPaymentMethodList() {
    let _pmList = this.paymentMethodList;
    return _pmList;
  }

  getChargeableAmount() {
    let _amount;
    if (this.includeTaxes)
      _amount = this.bookingItemBill.totalCharges + this.bookingItemBill.taxes;
    else if (!this.includeTaxes) _amount = this.bookingItemBill.totalCharges;
    return _amount;
  }

  getAppAttribute() {
    this.flightService.getAppAttributes().subscribe((data: any) => {
      if (data) {
        data.filter((d) => {
          return d.page === 'refundBookingPlayers'
        }).map((d) => {
          this.appAttribute = d
        });
        if (this.appAttribute && this.appAttribute.includeTaxes) this.includeTaxes = this.appAttribute.includeTaxes;
        if (this.appAttribute && this.appAttribute.enableRaincheck !== undefined) this.enableRaincheck = this.appAttribute.enableRaincheck;
      }
    });
  }

  async onCancelThisBooking() {
    let alert = await this.alertCtrl.create({
      header: 'Booking Cancellation',
      message: 'Are you sure you want to cancel this booking?',
      buttons: [
        {
          text: 'No',
          role: 'cancel',
        },
        {
          text: 'Yes',
          handler: () => {
            this.goCancelBooking(this.cancelReason);
          },
        },
      ],
    });
    alert.present();
  }

  goCancelBooking(data: any) {
    let _reason = data ? data.reason : '';
    let _bookingId = this.currentSlot.id;


    let _cancelledByClub = this.fromClub ? this.fromClub : false;
    this.flightService.cancelBooking(this.currentSlot.id, _cancelledByClub, _reason).subscribe((data) => {
      if (data.status === 200) {
        MessageDisplayUtil.showMessageToast(
          'Successfully cancel this booking',
          this.platform,
          this.toastCtl,
          5000,
          'bottom'
        );
      }
    }, (error) => {
      let _error = error;
      let _msg = _error.errorMessage;
      MessageDisplayUtil.showMessageToast(_msg, this.platform, this.toastCtl, 3000, "bottom");
      return false;
    })
  }

  async onUndoRefundClick(refund: RefundInstance) {
    if (!refund) return;
    let _totalAmount = refund.refundAmount;
    let alert = await this.alertCtrl.create({
      header: 'Undo Refund',
      message: 'Undo refund amount is ' + this.currency.symbol + ' ' + _totalAmount + ". Do you want to proceed?",
      buttons: [
        {
          text: 'No',
          role: 'cancel',
        },
        {
          text: 'Yes',
          handler: () => {
            this.undoRefundBooking(refund);
          },
        },
      ],
    });
    alert.present();
  }

  undoRefundBooking(refund: RefundInstance) {
    let _bookingId = this.currentSlot.id;
    let _refundInstanceId = refund.id;
    this.flightService
      .undoRefundBooking(_bookingId, _refundInstanceId)
      .subscribe(
        (data) => {
          if (data) {
            MessageDisplayUtil.showMessageToast('Successfully undo selected refund', this.platform, this.toastCtl, 5000, "bottom");
            this.bookingDiscounts = [];
            let _data = data;
            // if(_data) this.currentSlot = _data;
            if (_data) {
              this.currentSlot = _data;
              this.bookingDiscounts = [];
              // this.bookingDiscounts.push(..._data.bookingDiscounts);
              this.bookingDiscounts = JSON.parse(
                JSON.stringify(_data.bookingDiscounts)
              );
              let _totalWaive;
              if (this.bookingDiscounts.length > 0)
                this.bookingDiscounts.forEach((bd) => {
                  bd.toggleDetails = false;
                  _totalWaive += bd.amountDeducted;
                });
              // this.adjustableAmount = this.bookingItemBill.totalCharges - _totalWaive;
            }
          }
          this.getBookingItemizedBill();
        },
        (error) => {
          if (error) {
            let _error = error;
            MessageDisplayUtil.showErrorToast('Failed to undo selected refund.' + _error.errorMessage, this.platform, this.toastCtl, 5000, "bottom");
          }
        }
      );
  }
  checkClubHasWallet() {
    if (!this.appAttribute) return false;
    if (this.bookingItemBill && this.bookingItemBill.payments) {
      let _playerHasWallet;
      _playerHasWallet = this.bookingItemBill.payments.filter((pay) => {
        return pay.paymentMethod.toLowerCase() === 'club wallet';
      })
      if (!_playerHasWallet || (_playerHasWallet && _playerHasWallet.length === 0)) return false;
    }
    if (this.appAttribute) {
      let _currentClubId = this.currentSlot.clubData.id;
      if (this.appAttribute.allClubsWallet)
        return true;
      else if (!this.appAttribute.clubWallet || (this.appAttribute.clubWallet && this.appAttribute.clubWallet.length === 0))
        return false
      else {
        let _clubHasWallet;
        if (this.appAttribute.clubWallet) {
          this.appAttribute.clubWallet.filter((cw) => {
            return cw.clubId === _currentClubId
          }).map((cw) => {
            _clubHasWallet = cw;
          })
          return _clubHasWallet && _clubHasWallet.enableWallet
        }
      }
    }
  }

  setAdditionalCharges() {
    let _adjustmentAmount = Math.abs(this.waiveOffAmount);
    if (this.isAdditionalCharges) {
      this.waiveOffAmount = _adjustmentAmount * -1;
    } else {
      this.waiveOffAmount = Math.abs(this.waiveOffAmount);
    }
  }

  checkRefundAmountPlayer(i: number) {
    if (this.refundAmountPlayers[i] < 0)
      this.refundAmountPlayers[i] = this.refundAmountPlayers[i] * -1;
  }

  onSelectRaincheckOpt() {
    this.setExpiryDays = this.getRaincheckDetails('expiryDays');
    // setTimeout(()=>{
    this.initRaincheckProcess();
    setTimeout(() => {
      this.refundPlayers.forEach((r, idx, arr) => {
        this.refundReasonPlayers[idx] = 'Rain Check'
      })
    }, 750)
    // },500)
  }

  getPlayerBillItems(i, player) {
    // if(!player) return;
    // if(!this.getSinglePlayer(i)) return;

    if (!this.currentSlot) return;
    if (this.currentSlot && this.currentSlot.bookingPlayers.length === 0) return;
    // let _bpId = this.getBookingPlayers()[i].id;
    let _bpId = this.currentSlot.bookingPlayers[i].id;
    // this.currentSlot.bookingPlayers.forEach((bp, idx, arr)=>{
    // let _bpId = this.currentSlot.bookingPlayers.filter((bp)=>{
    //     return bp && bp.player && bp.player.id === _bpId
    // })
    // let _player = x.
    this.bookingItemBill.playerCharges.filter((pc: any) => {

      return pc.bookingPlayerId === _bpId
      // pc.bookingPlayerId 
    }).map((pc) => {
      let _amount = 0;
      this.refundPlayers[i] = true;
      _amount = pc.billItems.map((item) => {
        return item.itemPrice
      })
        .reduce((a, b) => {
          return a + b
        }, 0);

      this.refundAmountPlayers[i] = _amount;
    })
    // })
  }
  initRaincheckProcess() {
    if (this.fromClub)
      setTimeout(() => {
        this.currentSlot.bookingPlayers.forEach((bp, idx) => {
          if (this.getRaincheckDetails('hasExpiry')) this.refundExpiryPlayers[idx] = this.setExpiryDays;

          this.bookingItemBill.playerCharges.filter((pc: any) => {
            return pc.bookingPlayerId === bp.id
          }).map((pc) => {
            let _amount = 0;
            this.refundPlayers[idx] = true;
            _amount = pc.billItems.map((item) => {
              return item.itemPrice
            })
              .reduce((a, b) => {
                return a + b
              }, 0);

            this.refundAmountPlayers[idx] = _amount;
            this.refundPlayersReason[idx] = "Raincheck of amount " + this.currency.symbol + " " + _amount.toFixed(2);

          })
        })
      }, 500);
  }
  getRaincheckDetails(attribute: string) {

    if (!this.raincheckOptionList) return;
    if (this.raincheckOptionList && this.raincheckOptionList.length === 0) return;
    if (!this.selectedRaincheckOpt) return;
    let _raincheckDetails = this.raincheckOptionList.filter((rc) => {
      return rc.id === this.selectedRaincheckOpt
    }).pop()

    switch (attribute) {
      case 'hasExpiry':
        return _raincheckDetails.expires
      case 'expiryDays':
        return _raincheckDetails.expiryDays;
      case 'expiryDate':
        let _expDate = moment().add(this.setExpiryDays, 'days').format("ddd, DD MMM YYYY")
        return _expDate;
    }

  }

  onClearRaincheckAmount() {
    this.currentSlot.bookingPlayers.forEach((player, idx) => {
      this.refundPlayers[idx] = false;
      this.onRefundToPlayer(null, player, idx);
    })
  }

  goApplyRaincheck() {
    this.onApplyWaiveOff();
    this.refundAmountPlayers.forEach((r, idx, arr) => {
      let _player = this.getSinglePlayer(idx);
      if (r > 0)
        this.onAddTopupPlayer(_player, r)
          .then((result: any) => {
            if (result && result.status === 'success') {
              if (idx === (arr.length - 1)) {
              }
            }
          }).catch((error) => {
          })
    })
  }
  async onApplyRaincheckClick() {
    let _totalAmount = 0;
    _totalAmount = this.refundAmountPlayers.reduce((a, b) => {

      return a + b;
    });
    if (!this.selectedRaincheckOpt) {
      MessageDisplayUtil.showMessageToast('Please select a raincheck option to proceed.',
        this.platform, this.toastCtl, 5000, "bottom");
      return false;
    }
    if (this.getRefundableAmount() < 0) {
      MessageDisplayUtil.showMessageToast('There is no refundable amount available',
        this.platform, this.toastCtl, 5000, "bottom");
      return false;
    }
    if (this.getRefundableAmount() < _totalAmount) {
      MessageDisplayUtil.showMessageToast('Raincheck amount is more than available amount to proceed',
        this.platform, this.toastCtl, 5000, "bottom");
      return false;
    }
    if (this.currentSlot.amountPaid < this.getRefundableAmount()) {
      MessageDisplayUtil.showMessageToast('Amount paid is less than refundable amount',
        this.platform, this.toastCtl, 5000, "bottom");
      return false;
    }
    if (_totalAmount === 0) {
      MessageDisplayUtil.showMessageToast('Please select a player and enter raincheck amount',
        this.platform, this.toastCtl, 5000, "bottom");
      return false;
    }
    this.waiveOffAmount = _totalAmount;
    this.waiveOffReason = 'Raincheck of total amount ' + this.currency.symbol + ' ' + _totalAmount.toFixed(2);
    if (this.selectedRaincheckOpt === 'CLBC') {
      this.clubPaymentMethod = 'clbc';
      let alert = await this.alertCtrl.create({
        header: 'Booking Raincheck',
        message: '<span>Total raincheck amount is <b>' + this.currency.symbol + ' ' + this.numberWithCommas(_totalAmount) + "</b>. Do you want to proceed?</span>",
        buttons: [{
          text: 'No',
          role: 'cancel'
        }, {
          text: 'Yes',
          handler: () => {
            this.onApplyRefundClick();
          }
        },]
      });
      alert.present();
    } else if (this.selectedRaincheckOpt === 'WALT') {
      this.clubPaymentMethod = 'walt';
      let alert = await this.alertCtrl.create({
        header: 'Booking Raincheck (with validity)',
        message: '<span>Total raincheck amount is <b>' + this.currency.symbol + ' ' + this.numberWithCommas(_totalAmount) + "</b>. Do you want to proceed?</span>",
        buttons: [{
          text: 'No',
          role: 'cancel'
        }, {
          text: 'Yes',
          handler: () => {
            // this.goApplyRaincheck();
            this.onApplyRefundClick();
          }
        },]
      });
      alert.present();
    }
  }

  onAddTopupPlayer(player, amount: number) {
    return new Promise((resolve, reject) => {
      // goAddClubPlayerTopup() {
      let _clubId = this.clubId;
      let _playerId = player.id;
      let _currDate = moment().format("YYYY-MM-DD")
      let _expDate = moment().add(this.setExpiryDays, 'days').format("YYYY-MM-DD")
      let _params = {
        topUpDate: _currDate,
        expiryDate: _expDate,
        amount: amount
      }

      this.flightService.addClubPlayerTopup(_clubId, _playerId, _params)
        .subscribe((data) => {

          if (data) {
            resolve({
              status: 'success',
              data: data
            })
            this.modalCtl.dismiss({
              needRefresh: true,
              fromClub: this.fromClub
            });
            MessageDisplayUtil.showMessageToast('Successfully topup for selected player', this.platform, this.toastCtl,
              5000, "bottom");
            return;
          }
        }, (error) => {
          reject({
            status: 'failed',
            error: error,
          })
        })
    })
  }

  initReasonRefundList() {
    this.refundReasonList.push({
      id: 'Overpayment',
      name: 'Overpayment'
    });
    this.refundReasonList.push({
      id: 'Rain Check',
      name: 'Rain Check'
    });
    this.refundReasonList.push({
      id: 'Flight Cancelled by Club',
      name: 'Flight Cancelled by Club'
    });
    this.refundReasonList.push({
      id: 'Other',
      name: 'Other'
    })
  }

  onSelectRefundReasonType(idx) {
    if (this.refundPlayers[idx]) {
      if (this.refundPlayersReason[idx] && this.refundPlayersReason[idx].length > 0)
        this.refundPlayersReason[idx] = "[" + this.refundReasonPlayers[idx] + "]" + " " + this.refundPlayersReason[idx]
      else this.refundPlayersReason[idx] = "[" + this.refundReasonPlayers[idx] + "]"
    }
  }

  clearRefundDetails() {
    if (this.optionTypes !== 'raincheck')
      this.refundPlayers.forEach((p, idx) => {
        this.refundPlayers[idx] = false;
        this.onRefundToPlayer(null, null, idx)
      })
    this.refundReasonPlayers.forEach((r, idx) => {
      this.refundReasonPlayers[idx] = null;
    })
    this.refundPlayersReason.forEach(p => "")
    this.refundAmountPlayers.forEach(p => 0)
  }
}
